import React, { ReactNode } from "react";
import "../../../assets/styles/doctors-stage.scss";

type DoctorsStageProps = {
    /** Arka plan görseli (zorunlu) */
    bgImage: string;
    /** Overlay rengi (default: koyu mavi ton) */
    overlay?: string; // rgba veya linear-gradient
    /** İçerik maksimum genişlik (px veya CSS değeri) */
    maxWidth?: number | string;
    /** Grid kolon sayıları */
    colsDesktop?: number;  // >=992px
    colsTablet?: number;   // 576–991px
    colsMobile?: number;   // <576px
    /** İç yükselik/padding (top/bottom) */
    paddingY?: string;     // e.g. "clamp(48px, 8vw, 120px)"
    /** Grid kartları/slot (kartlarını buraya children olarak ver) */
    children?: ReactNode;
    /** CTA ayarları */
    ctaText?: string;
    onCtaClick?: () => void;
    showCta?: boolean;
};

const DoctorsStage: React.FC<DoctorsStageProps> = ({
    bgImage,
    overlay = "rgba(7, 42, 84, .78)", // koyu mavi overlay
    maxWidth = 1200,
    colsDesktop = 4,
    colsTablet = 2,
    colsMobile = 1,
    paddingY = "clamp(48px, 8vw, 120px)",
    children,
    ctaText = "Tüm Hekimler",
    onCtaClick,
    showCta = true,
}) => {
    const styleVars = {
        // @ts-ignore - CSS custom properties
        "--ds-bg": `url(${bgImage})`,
        "--ds-overlay": overlay,
        "--ds-max": typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth,
        "--ds-cols": colsDesktop.toString(),
        "--ds-cols-md": colsTablet.toString(),
        "--ds-cols-sm": colsMobile.toString(),
        "--ds-py": paddingY,
    } as React.CSSProperties;

    return (
        <section className="doctors-stage" style={styleVars}>
            <div className="ds-inner">
                {children}

                {showCta && (
                    <div className="ds-cta">
                        <button
                            type="button"
                            className="ds-cta-btn"
                            onClick={onCtaClick}
                        >
                            {ctaText}
                            <i className="bi bi-chevron-right" />
                        </button>
                    </div>
                )}
            </div>
        </section>
    );
};

export default DoctorsStage;
